import { ALL_AUTH_METHODS } from './auth-method-util';
import { queryify } from './url-util';

export function getServer() {
  return window?.server || {};
}

function getSSOHint() {
  return getServer().sso_hint;
}

export function getAccount() {
  return getServer().account;
}

export function getClient() {
  return getServer().client;
}

export function getClientURLs() {
  return getServer().client_urls;
}

export function getEmail() {
  return getServer().email;
}

export function getEmailCode() {
  return getServer().email_code;
}

export function getError() {
  return getServer().error;
}

export function getInviteCode() {
  return getServer().invite_code;
}

export function getInviterEmail() {
  return getServer().invite_sender_email;
}

export function getInviteType() {
  return getServer().invite_type;
}

export function getPasswordCode() {
  return getServer().password_code;
}

export function getRecaptchaKey() {
  return getServer().recaptcha_site_key;
}

export function getRedirect() {
  return getServer().redirect;
}

export function getReferral() {
  return getServer().referral;
}

export function getScopes() {
  return getServer().scopes;
}

export function getSSO() {
  return getServer().sso;
}

export function getToken() {
  return getServer().token;
}

export function getUser() {
  return getServer().user;
}

export function getUserId() {
  return getServer().user_id;
}

export function getXSRFToken() {
  return getServer()._xsrf;
}

export function getAuthMethods() {
  return getServer().auth_methods || ALL_AUTH_METHODS;
}

export function getThirdParty() {
  return getServer().third_party;
}

export function getProduct() {
  return getServer().product;
}

export function getUserCode() {
  return getServer().user_code;
}

export function getStatus() {
  return getServer().status;
}

export function serverToQueryString(includeAuthMethods) {
  // Does not need to add everything from the server to the query params.
  // This should only add the params that are actually taken in by the server for the pages that this query is
  // used for (/forgot_password, /login, /register)

  let params = {
    invite_code: getInviteCode(),
    product: getProduct(),
    redirect: getRedirect(),
    referral: getReferral(),
    sso_hint: getSSOHint()
  };

  if (includeAuthMethods) {
    params = { ...params, ...getAuthMethods() };
  }

  return queryify(params);
}
